// TAS-274: route-level gate for TV-only phases. In TV mode a non-GM player's
// phone shows the "look at the big screen" placeholder instead of the full
// screen (which now lives on the TV). The GM keeps the real screen — that's
// where the reveal prompts and advance controls live. In Phone mode (or when
// ff_tv_mode is off, which forces gameViewMode to 'phone') this is a no-op
// passthrough, so existing behaviour is unchanged.
import { useGameFlow } from '../../contexts/GameFlowProvider';
import LookAtScreen from './LookAtScreen';

export default function TvPhoneGate({ subtitle, children }) {
  const { gameViewMode, isGm } = useGameFlow();
  if (gameViewMode === 'tv' && !isGm) return <LookAtScreen subtitle={subtitle} />;
  return children;
}
